// extracted by mini-css-extract-plugin
export var pillWrapper = "_oe-0";
export var showOverflow = "_oe-1";